import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../../constants/constants';
import SurchargeRateForm from './surchargeRateForm';
import { resetSurchargeRates } from '../../../reducers/surchargeRateReducer';

interface IAddSurchargeRateProps {
    classes: any;
    theme: Theme;
    match: any;
    resetSurchargeRates: any;
    steps: Array<number>;
    surchargeRateId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetSurchargeRates: () => dispatch(resetSurchargeRates())
});

const mapStoreToProps = (store: RootState, ownProps: IAddSurchargeRateProps) => {
    return {
        surchargeRateId: ownProps.match.params?.surchargeRateId ? Number(ownProps.match.params?.surchargeRateId) : undefined
    };
};

class AddSurchargeRate extends Component<IAddSurchargeRateProps> {
    componentWillUnmount() {
        const { resetSurchargeRates } = this.props;

        resetSurchargeRates();
    }

    render() {
        const { classes, steps, surchargeRateId, type } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <SurchargeRateForm surchargeRateId={surchargeRateId} steps={steps} type={type} />
                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddSurchargeRate));